import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const proofPoints = ['Web a medida', 'Carta digital', 'Gestión incluida'];
const principles = [['01', 'Estrategia útil', 'Una estructura definida antes de diseñar.'], ['02', 'Diseño con intención', 'Cada sección facilita una decisión.'], ['03', 'Base preparada', 'Una presencia que puedes seguir cuidando.']];
export function Hero() {
  return <section className="border-b border-white/10 bg-[#0a0a0a] pt-24 sm:pt-28" data-id="element-41" data-mp="x9uqrn89208u">
      <div className="container mx-auto px-6 md:px-12" data-id="element-42" data-mp="sbb2vha3iedu">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-6xl py-12 sm:py-16 lg:py-20" data-id="element-43" data-mp="s9q75oc1opee">
          <div className="flex items-center gap-4" data-id="element-44" data-mp="382ffxqfwf8fz">
            <p className="eyebrow" data-id="element-45" data-mp="380vy3velgpc3">Growthly · agencia digital</p>
            <span className="h-px w-10 bg-white/20" aria-hidden="true" data-id="element-46" data-mp="3j7zhzqi0g6kd" />
          </div>
          <h1 className="mt-6 max-w-4xl text-[2.5rem] font-medium leading-[1.02] tracking-[-0.055em] text-white sm:text-6xl sm:leading-[0.98] lg:text-7xl" data-id="element-47" data-mp="3o7c05xxxspgm">
            Tu negocio merece una presencia que esté a su altura.
          </h1>
          <div className="mt-8 grid gap-8 border-t border-white/10 pt-7 lg:grid-cols-[minmax(0,1fr)_minmax(220px,0.48fr)] lg:gap-14" data-id="element-48" data-mp="3e84mtar7cuti">
            <div data-id="element-49" data-mp="30g6lvn7na58f">
              <p className="max-w-2xl text-base leading-relaxed text-neutral-300 sm:text-lg" data-id="element-50" data-mp="358hleoyh3p0g">
                Diseñamos una base digital clara para que tus clientes entiendan
                tu valor, encuentren lo importante y sepan cómo avanzar.
              </p>
              <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-51" data-mp="2vj7sx7zpw4bt">
                <Link to="/checkout" className="button-primary group sm:min-w-[190px]" data-id="element-52" data-mp="2hk87sabey7ke">
                  Iniciar mi proyecto
                  <ArrowRightIcon size={17} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-53" data-mp="2ljz0ijki2xrk" />
                </Link>
                <Link to="/proceso" className="button-secondary sm:min-w-[150px]" data-id="element-54" data-mp="ibypocqjh226">
                  Ver el proceso
                </Link>
              </div>
            </div>
            <div className="border-l border-white/15 pl-5 sm:pl-6" data-id="element-55" data-mp="dbapp1kc1avt">
              <p className="meta-label" data-id="element-56" data-mp="1b0drtyoknpw3">Una propuesta, un objetivo</p>
              <p className="mt-4 text-sm leading-relaxed text-neutral-300" data-id="element-57" data-mp="161jaz2a60bem">
                Ordenar tu mensaje, elevar la percepción de tu marca y facilitar
                la siguiente conversación.
              </p>
            </div>
          </div>
          <div className="mt-10 flex flex-wrap gap-x-5 gap-y-3 border-t border-white/10 pt-5" data-id="element-58" data-mp="x37cke3249bm">
            {proofPoints.map(point => <span key={point} className="inline-flex items-center gap-2 text-xs font-medium text-neutral-300" data-id="element-59" data-mp="3hqu2ybi9aa1p">
                <CheckIcon size={14} className="text-white" aria-hidden="true" data-id="element-60" data-mp="1x785hp5ovtun" />
                {point}
              </span>)}
          </div>
        </motion.div>
      </div>

      <div className="border-t border-white/10 bg-black" data-id="element-61" data-mp="268oebsguvnwr">
        <div className="container mx-auto grid max-w-6xl px-6 md:px-12 sm:grid-cols-3" data-id="element-62" data-mp="2b0zduu7op7os">
          {principles.map(([number, title, detail]) => <article key={number} className="border-b border-white/10 py-6 last:border-b-0 sm:border-b-0 sm:border-r sm:px-7 sm:first:pl-0 sm:last:border-r-0" data-id="element-63" data-mp="2g1wvn5os7zpr">
              <p className="meta-number" data-id="element-64" data-mp="2oye6s8x5bxli">{number}</p>
              <h2 className="mt-4 text-sm font-medium text-white" data-id="element-65" data-mp="2tztr1yri202u">{title}</h2>
              <p className="mt-1.5 text-xs leading-relaxed text-neutral-400" data-id="element-66" data-mp="umpqa2b9nmz0">
                {detail}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}